// src/pages/ComingSoon.tsx


export default function ComingSoon() {
    return (
      <div className="min-h-screen bg-gradient-to-r from-indigo-100 via-purple-200 to-pink-200 flex items-center justify-center px-4">
        <div className="bg-white rounded-3xl shadow-2xl p-10 max-w-md w-full text-center transform transition-all hover:scale-105 duration-300 ease-in-out">
          <h1 className="text-4xl font-bold text-purple-800 mb-6">
             Coming Soon
          </h1>
          <p className="text-gray-600 mb-8">
            We’re building something amazing. Stay tuned for updates!
          </p>
  
        
  
          <p className="text-sm text-gray-500">
            We'll notify you when we're ready to launch. Get ready!
          </p>
        </div>
      </div>
    );
  }
  